import { motion } from "motion/react";
import type { ReactNode } from "react";
import { ScrollTrigger } from "../../lib/gsap";
import { Footer } from "./Footer";

/** Envolve cada página: fade + slide leve na entrada/saída. */
export const PageTransition = ({ children }: { children: ReactNode }) => (
  <motion.div
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -8 }}
    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
    // Recalcula os gatilhos de scroll depois que a página assentou.
    onAnimationComplete={() => ScrollTrigger.refresh()}
  >
    <main id="conteudo" tabIndex={-1} className="outline-none">
      {children}
    </main>
    <Footer />
  </motion.div>
);
